<formly-form [form]="form" [model]="model" [fields]="fields" />

<ish-payment-save-checkbox *ngIf="paymentMethod" [paymentMethod]="paymentMethod" [form]="parentForm" />

<div class="row">
  <div class="offset-md-4 col-md-8">
    <button type="submit" class="btn btn-primary" [disabled]="submitDisabled" (click)="submitParameterForm()">
      {{ 'checkout.account.submit.button.label' | translate }}
    </button>
    <button type="button" class="btn btn-secondary" (click)="cancelNewPaymentInstrument()">
      {{ 'checkout.cancel.button.label' | translate }}
    </button>
  </div>
</div>
